import { KeyboardDoubleArrowDown } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import home_bg from 'src/assets/home_bg.webp'
import home_mb_bg from 'src/assets/home_mb_bg.webp'
import TextSection from 'src/components/shared/TextSection'

const Home = () => {
  return (
    <Box>
      <Box
        sx={{
          height: { xs: 'calc(100vh - 56px)', md: 'calc(100vh - 65px)' },
          maxHeight: '900px',
          backgroundImage: { xs: `url(${home_mb_bg})`, md: `url(${home_bg})` },
          backgroundSize: 'cover',
          backgroundPosition: { xs: 'center', md: 'initial' },
          backgroundRepeat: 'no-repeat',
          backgroundBlendMode: 'overlay',
          backgroundColor: '#313131ab',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <Typography
          variant="h4"
          fontWeight={600}
          fontStyle="italic"
          color="#f4f4f4"
          textAlign="center"
          sx={{ width: { xs: '80%', sm: '90%', md: '700px' } }}
        >
          Our goal is to build a long-lasting partnership with our clients.
        </Typography>
        <Box
          sx={{
            position: 'absolute',
            bottom: '25px',
            transition: 'all 0.2s',
            '&:hover': {
              bottom: '15px',
            },
          }}
        >
          <KeyboardDoubleArrowDown fontSize="large" sx={{ fill: '#fff' }} />
        </Box>
      </Box>
      <TextSection
        title="Vision & Mission"
        text="Our Mission is to provide the best possible solutions and applications to address the objectives and to meet the needs of our clients. INFOGIS provide custom software development and maintains the highest quality of telecommunications service by providing and maintaining the health and security of the network."
        buttonText="Learn More"
        buttonPath="/about-us"
      />
    </Box>
  )
}

export default Home
